import securitytype from './securitytype';

const project = {
  namespaced: true,
  state: {
    isEdit: false,
    isEditId: '',
    key: '',
    finished: false,
    projectList: [],
    projectId: '',
    projectName: '',
    content: '',
    proCur: 0, //当前项目
    branchComId: '', //分公司id
    // resetProject: false,
    securityfrom: securitytype,
    qualityqueryOther: {
      subProjectName: '',
      companyName: '',
    },
    measure: {}, //实测实量
    qualityquery: { //质量检查-筛选
      employeeIds: [],
      statusIds: [],
      typeIds: [],
      subProjectIds: [],
      areaIds: [],
      checkDateBegin: '',
      checkDateEnd: '',
      rectifyTermBegin: '',
      rectifyTermEnd: '',
      resultId: ''
    },
    addqualityAreaGetDataIni: {
      id: '', //请求整改单位参数id
      name: '',
      unqualified: {
        companylist: []
      }
    },
    addqualityAreaGetData: {
      id: '', //请求整改单位参数id
      name: '',
      unqualified: {
        companylist: []
      }
    },
    addqualityIni: { //添加质量安全检查
      subProjectTypeId: '', //分部分项
      subProjectTypetext: '',
      areaId: '', //责任区域
      respAreaId: '', //检查区域
      tabactive: '', //当前选中(合格/不合格)
      checkDescribe: '', //具体部位描述
      qualified: [ //合格
        {
          record: '', //检查记录
          images: [],
          fileList: [], //图片
          isQualified: '1',
          companyname: ''
        }
      ],
      unqualified: [ //不合格
        {
          images: [],
          fileList: [], //图片
          treeLabelId: '', //安全隐患
          // treeLabeltext: '',
          safeDangerText: '',
          descriptionId: '', //安全隐患问题
          description: '', //安全隐患问题描述/问题描述
          problemTypeId: '', //问题分类
          problemTypename: '',
          coordinate: '', //问题具体位置
          coordinatearr: [],
          rectifierId: '', //整改人
          rectifiertext: '',
          dutyId: '', //责任人
          dutyIdName: '',
          rectifyTerm: '', //整改期限
          rectifyTermtext: '',
          rectifierCompanyId: '', //整改单位
          companyname: '',
          reCheckId: '', //复查人
          reCheckname: '',
          isQualified: '0',
          statusId: '',
          // statusId: '621958018187268096',
        }
      ]
    },
    addquality: { //添加质量安全检查
      subProjectTypeId: '', //分部分项
      subProjectTypetext: '',
      areaId: '', //责任区域=整改单位
      respAreaId: '', //检查区域
      tabactive: '', //当前选中(合格/不合格)
      checkDescribe: '', //具体部位描述
      qualified: [ //合格
        {
          record: '', //检查记录
          images: [],
          fileList: [], //图片
          isQualified: '1',
          companyname: ''
        }
      ],
      unqualified: [ //不合格
        {
          images: [],
          fileList: [], //图片
          treeLabelId: '', //安全隐患
          // treeLabeltext: '',
          safeDangerText: '',
          descriptionId: '', //安全隐患问题描述
          description: '',
          problemTypeId: '', //问题分类
          problemTypename: '',
          coordinate: '', //问题具体位置
          coordinatearr: [],
          rectifierId: '', //整改人
          rectifiertext: '',
          rectifyTerm: '', //整改期限
          rectifyTermtext: '',
          rectifierCompanyId: '', //整改单位
          companyname: '',
          reCheckId: '', //复查人
          reCheckname: '',
          isQualified: '0',
          statusId: '',
          // statusId: '621958018187268096',
          CompanyChoicedId: '', //所选整改单位所在列表id
        }
      ]
    },
    //安全质量之星
    star: {
      path: '',
      starType: '',
      employeeName: '',
      employeeId: '',
      phone: '',
      respAreaId: '',
      respAreaName: '',
      cardNum: '',
      cardValue: '',
      rewardReasons: '',
      rewardReasonsId: '',
      subcontractorName: '',
      subcontractorId: '',
      remark: '',
      images: [],
      fileList: [],
      typeWorkId: '',
      behaviorStarCardDTOS: []
    },
    measureUnqualified: undefined,

    //安全检查内容 （+为自定义需要）
    safety: {
      tabactive: '', //当前选择合格/不合格tabs
      checkDescribe: "", // 具体部位
      constructionPhaseId: '', // 施工阶段id
      constructionPhaseName: '', // 施工阶段name
      isQualified: '', // 1合格; 0不合格
      respAreaId: '', // 检查区域ID
      respAreaName: '', // 检查区域name+
      respAreaNamePath: '', // 检查区域name+
      subcontractorId: '', //分包商IDqualified
      subcontractorName: '', //分包商名称（逗号隔开）
      typeId: '', // 检查类型id
      typeName: '', // 检查类型 name+
      creatorName: '', //检查人
      dangerProject: '0', //是否危大工程;0不是，1是
      // safetyAuditStatusEnum: '', //安监安全检查记录表状态**该值对应**
    },
    safetyList: {
      QualifiedDTO: [{
        images: [], //上传图片ids
        imagesFileInfo: [], //上传图片文件
        record: '', //检查记录
        securityControlEnum: '', //安全控制情况
        // securityControlEnumStr: '', //安全控制情况返回字段
        sendUserIds: '', //抄送人id（逗号分割）
        sendUserNames: '', //抄送人name（逗号分割）
        // sendUserNamesArr:[], //抄送人namesArr+
        treeLabelId: '', //安全隐患id
        treeLabelName: '', //安全隐患name+
      }], //合格
      UnqualifiedDTO: [{
          images: [], //上传图片ids
          imagesFileInfo: [], //上传图片文件
          isRectification: '1', //是否整改;0否，1是
          problemDescription: '', //问题描述
          rectificationContent: '', //整改内容
          rectificationTime: '', //整改期限
          rectificationUserId: '', //整改人ID
          rectificationUserName: '', //整改人name
          reviewUserId: '', //复查人ID
          reviewUserName: '', //复查人name
          securityControlEnum: '', //问题级别
          // securityControlEnumStr: '', //问题级别返回字段
          sendUserIds: '', //抄送人Ids（逗号分割）
          sendUserNames: '', //抄送人names（逗号分割）
          treeLabelId: '', //安全隐患id
          treeLabelName: '', //安全隐患name
        }

      ], //不合格
    },
    safetyListIni: { //初始化
      QualifiedDTO: [{
        images: [], //上传图片ids
        imagesFileInfo: [], //上传图片文件
        record: '', //检查记录
        securityControlEnum: '', //安全控制情况
        // securityControlEnumStr: '', //安全控制情况返回字段
        sendUserIds: '', //抄送人id（逗号分割）
        sendUserNames: '', //抄送人name（逗号分割）
        // sendUserNamesArr:[], //抄送人namesArr+
        treeLabelId: '', //安全隐患id
        treeLabelName: '', //安全隐患name+
      }], //合格
      UnqualifiedDTO: [{
          images: [], //上传图片ids
          imagesFileInfo: [], //上传图片文件
          isRectification: '1', //是否整改;0否，1是
          problemDescription: '', //问题描述
          rectificationContent: '', //整改内容
          rectificationTime: '', //整改期限
          rectificationUserId: '', //整改人ID
          rectificationUserName: '', //整改人name
          reviewUserId: '', //复查人ID
          reviewUserName: '', //复查人name
          securityControlEnum: '', //问题级别
          // securityControlEnumStr: '', //问题级别返回字段
          sendUserIds: '', //抄送人Ids（逗号分割）
          sendUserNames: '', //抄送人names（逗号分割）
          treeLabelId: '', //安全隐患id
          treeLabelName: '', //安全隐患name
        }

      ], //不合格
    },
    // 机械设备表单
    equipment: {
      baseForm: {
        branchComId: '', // 分公司ID
        projectId: '', // 项目ID
        ownOrRent: true, // 是否自有-自租
        materialCode: '', // 机械设备编码（物资编码）
        specModel: '', // 规格型号
        propertyUnit: '', // 产权单位
        installUnit: '', // 安装单位
        manufacturer: '', // 生产厂家
        entryTime: '', // 进场时间
        
        equipTypeId: '', // 设备类型
        equipmentClass: '', // 设备分类
        appearanceDate: '', // 出场日期
        equipCode: '', // 设备编码
        recordNum: '', // 使用登记证
        certNum: '', // 合格证号
        respEmployeeId: '', // 责任人员工ID
        acceptanceInfo: '', // 验收情况
        testReportNum: '', // 检测报告编号
        equipStatusId: '', // 使用状态
        
        assetsUnitFile: [], // 产权单位资质
        installUnitFile: [], // 安装单位资质
        equipmentFile: [], // 设备合格证
        useFile: [], // 使用登记证(设备备案证)
        checkFile: [], // 安装验收/四方验收
        detectionFile: [], // 第三方检测报告
        otherFile: [], // 其他
        // auditStatus: '', // 状态 [ DRAFT, SUBMITTED, PAST, REJECTED ]
        // fileInfoList: [], // 
        // name: '', // 设备名称
      },
      names: {
        branchComName: '',
        projectName: '',
        materialName: '', // 机械设备编码名称（物资编码）
        equipTypeName: '', // 设备类型名称
        equipmentClassName: '', // 设备分类名称
        respEmployeeName: '', // 责任人员工名称
        equipStatusName: '', // 使用状态名称
      }
    },
    // 安全验收表单
    acceptanceForm: {
      // 计划外安全验收
      outPlan: {
        baseForm: {
          acceptanceDate: "",
          acceptancePart: "",
          acceptanceResEmployeeId: "",
          acceptanceTypeId: "",
          branchComId: "",
          id: null,
          isImport: false,
          levelTypeId: "",
          projectId: "",
          remark: "",
          sortNum: "",
          subContractorId: "",
          subContractorName: "",
          userIds: [],
          userNames: "",
          creatorName: "",
        },
        names: {
          projectName: "",
          acceptanceTypeName: "",
          levelTypeName: "",
          acceptanceResEmployeeName: "",
        }
      }
    }
  },
  mutations: {
    setVal(state, {key, val}){
      console.log('setVal',key,val)
      state[key] = JSON.parse(JSON.stringify(val))
    },
    itemfrom(state, title) {
      return state[title];
    },
    emptycondition(state) {
      for (let item in state.qualityqueryOther) {
        let type = state.qualityqueryOther[item].constructor;
        if (type == String) {
          state.qualityqueryOther[item] = "";
        }
      }
      for (let item in state.qualityquery) {
        let type = state.qualityquery[item].constructor;
        if (type == Array) {
          state.qualityquery[item] = [];
        } else if (type == Object) {
          state.qualityquery[item] = {};
        } else if (type == String) {
          state.qualityquery[item] = "";
        } else if (type == Number) {
          state.qualityquery[item] = 0;
        } else if (type == Boolean) {
          state.qualityquery[item] = false;
        }
      }
    },
    emptyproject(state) {
      state.projectList = [],
        state.projectId = '',
        state.projectName = '',
        state.content = ''
    },
    emptystar(state) {
      for (let item in state.star) {
        let type = state.star[item].constructor;
        if (type == Array) {
          state.star[item] = [];
        } else if (type == Object) {
          state.star[item] = {};
        } else if (type == String) {
          state.star[item] = "";
        } else if (type == Number) {
          state.star[item] = 0;
        } else if (type == Boolean) {
          state.star[item] = false;
        }
      }
      state.addqualityAreaGetData.name = '';
      state.addqualityAreaGetData.id = '';
      state.addquality.respAreaId = '';

    },
    projectListChange: (state, val) => {
      state.projectList = val
    },
    /**
     * 更新质量不合格的数据
     * @param {Number} index 序号
     * @param {Object} data 更新后的数据对象
     */
    UPDATE_ADDQUALITY_UNQUALIFIED(state, {
      index,
      data
    }) {
      state.addquality.unqualified[index] = data
    },

    /**以下为安全检查内容**/
    //整体设置safaty
    SatetySet(state, val) {
      for (let item in state.safety) {
        let type = state.safety[item]?.constructor;
        if (type == Array) {
          state.safety[item] = val ? val[item] : [];
        } else if (type == Object) {
          state.safety[item] = val ? val[item] : {};
        } else if (type == String) {
          state.safety[item] = val ? val[item] : "";
        } else if (type == Number) {
          state.safety[item] = val ? val[item] : 0;
        } else if (type == Boolean) {
          state.safety[item] = val ? val[item] : false;
        }
      }
      state.addqualityAreaGetData.name = '';
      state.addqualityAreaGetData.id = '';
    },
    SatetyListSet(state, val) { //清空安全检查合格不合格内容
      console.log(state.safetyList.QualifiedDTO)
      state.safetyList.QualifiedDTO.map((_item, index) => {
        for (let i in _item) {
          let types = _item[i].constructor;
          if (types == Array) {
            state.safetyList.QualifiedDTO[index][i] = val ? val[i] || [] : [];
          } else if (types == Object) {
            state.safetyList.QualifiedDTO[index][i] = val ? val[i] || {} : {};
          } else if (types == String) {
            state.safetyList.QualifiedDTO[index][i] = val ? val[i] || "" : "";
          } else if (types == Number) {
            state.safetyList.QualifiedDTO[index][i] = val ? val[i] || 0 : 0;
          } else if (types == Boolean) {
            state.safetyList.QualifiedDTO[index][i] = val ? val[i] : false;
          }
        }
      });
      state.safetyList.UnqualifiedDTO.map((_item, index) => {
        for (let i in _item) {
          let types = _item[i].constructor;
          if (types == Array) {
            state.safetyList.UnqualifiedDTO[index][i] = val ? val[i] || [] : [];
          } else if (types == Object) {
            state.safetyList.UnqualifiedDTO[index][i] = val ? val[i] || {} : {};
          } else if (types == String) {
            state.safetyList.UnqualifiedDTO[index][i] = val ? val[i] || "" : "";
          } else if (types == Number) {
            state.safetyList.UnqualifiedDTO[index][i] = val ? val[i] || 0 : 0;
          } else if (types == Boolean) {
            state.safetyList.UnqualifiedDTO[index][i] = val ? val[i] : false;
          }
        }
      });
    },
    // 机械设备表单赋值
    EquipmentSet(state, val) {
      for (let item in state.equipment.baseForm) {
        let obj = state.equipment.baseForm;
        let type = state.equipment.baseForm[item]?.constructor;
        if (type == Array) {
          obj[item] = val ? val[item] : [];
        } else if (type == String) {
          obj[item] = val ? val[item] : "";
        } else if (type == Boolean) {
          obj[item] = val ? val[item] : true;
        }  else {
          obj[item] = val ? val[item] : undefined;
        }
      }
      for (let item in state.equipment.names) {
        let obj = state.equipment.names;
        let type = state.equipment.names[item]?.constructor;
        if (type == Array) {
          obj[item] = val ? val[item] : [];
        } else if (type == Object) {
          obj[item] = val ? val[item] : {};
        } else if (type == String) {
          obj[item] = val ? val[item] : "";
        } else if (type == Number) {
          obj[item] = val ? val[i] || 0 : 0;
        } else {
          obj[item] = val ? val[item] : undefined;
        }
      }
    },
    AcceptanceOutPlanSet(state, val) {
      for (let item in state.acceptanceForm.outPlan.baseForm) {
        let obj = state.acceptanceForm.outPlan.baseForm;
        let type = state.acceptanceForm.outPlan.baseForm[item]?.constructor;
        if (type == Array) {
          obj[item] = val ? val[item] : [];
        } else if (type == String) {
          obj[item] = val ? val[item] : "";
        } else if (type == Boolean) {
          obj[item] = val ? val[item] : false;
        } else {
          obj[item] = val ? val[item] : undefined;
        }
      }
      for (let item in state.acceptanceForm.outPlan.names) {
        let obj = state.acceptanceForm.outPlan.names;
        let type = state.acceptanceForm.outPlan.names[item]?.constructor;
        if (type == Array) {
          obj[item] = val ? val[item] : [];
        } else if (type == Object) {
          obj[item] = val ? val[item] : {};
        } else if (type == String) {
          obj[item] = val ? val[item] : "";
        } else if (type == Number) {
          obj[item] = val ? val[i] || 0 : 0;
        } else {
          obj[item] = val ? val[item] : undefined;
        }
      }
    }
  },
  getters: {},
  actions: {

  },
}
export default project;
